import React, { createContext, useContext, useEffect, useState } from 'react'
import { fetchData, getEncodedCookie, setEncodedCookie, startPolling, toasterrormsg } from '../../../reusable'
import { useAuthStore } from '../store/UseAuthStore'

interface MenuContextType {
  fullMenu: any[]
  allowedPaths: string[]
  isMenuLoaded: boolean
  reloadMenu: () => void
}

const MenuContext = createContext<MenuContextType>({
  fullMenu: [],
  allowedPaths: [],
  isMenuLoaded: false,
  reloadMenu: () => { },
})

export const useMenuContext = () => useContext(MenuContext)

export const MenuProvider = ({ children }: { children: React.ReactNode }) => {
  const [fullMenu, setFullMenu] = useState<any[]>([])
  const [allowedPaths, setAllowedPaths] = useState<string[]>([])
  const [isMenuLoaded, setIsMenuLoaded] = useState(false)
  const { supportCount, setSupportCount } = useAuthStore()

  let adminData: any = sessionStorage.getItem('admin')
  let adminId = ''
  let isSuperAdmin = ''
  let roleId = ''
  if (adminData) {
    adminId = JSON.parse(adminData).adminId
    isSuperAdmin = JSON.parse(adminData).mainadminId
    roleId = JSON.parse(adminData).roleId
  } else {
    adminId = ''
  }

  const fetchMenu = async () => {
    try {
      const param = {
        adminId: isSuperAdmin == '0' ? '0' : adminId,
        roleId: roleId
      }
      const response: any = await fetchData('admin/menu', param)

      if (String(response?.status) === '200') {

        if (supportCount) {
          setSupportCount(false)
        }
        const data = response.data
        setFullMenu(data)

        const extractPaths = (menus: any[]): string[] => {
          const allPaths: string[] = []
          const collectPaths = (items: any[]) => {
            items.forEach((item) => {
            
              if (item.path) allPaths.push(item.path.trim())
              if (Array.isArray(item.submenu)) collectPaths(item.submenu)
            })
          }

          collectPaths(data)

          return allPaths
            .filter((path) => path.length > 0)
            .map((path) => (path.startsWith('/') ? path.substring(1) : path))
        }

        setAllowedPaths(extractPaths(data))
        setIsMenuLoaded(true)
      } else {
        toasterrormsg(response.message)
      }
    } catch (error) {
      console.error('MenuContext Fetch Error:', error)
    }
  }

  // useEffect(() => {
  //   if (adminId) {
  //     fetchMenu() // Initial fetch
  //   }

  //   const interval = setInterval(() => {
  //     if (adminId && document.visibilityState === 'visible') {
  //       fetchMenu() // Initial fetch
  //     } // Fetch again every 10 seconds
  //   }, 60000) // 10,000 ms = 10 seconds

  //   return () => clearInterval(interval) // Clear interval on unmount
  // }, [supportCount])

  // useEffect(() => {
  //   const { start, cleanup } = startPolling(fetchMenu, 15000);
  //   start();

  //   return () => cleanup(); // cleanup on unmount
  // }, []);


  // useEffect(() => {
  //   const stopPolling = startPolling(() => {
  //     fetchMenu()
  //   }, 180000); // 3 minutes

  //   return () => stopPolling(); // cleanup on unmount
  // }, []);

  useEffect(() => {
  // Start interval
    fetchMenu();

  const intervalId = setInterval(() => {
    fetchMenu();
  }, 180000); // runs every 3 minutes

  // Cleanup function — this runs when the component unmounts
  return () => {
    clearInterval(intervalId);
  };
}, []); // ✅ Empty dependency = runs only once


  return (
    <MenuContext.Provider
      value={{
        fullMenu,
        allowedPaths,
        isMenuLoaded,
        reloadMenu: fetchMenu,
      }}
    >
      {children}
    </MenuContext.Provider>
  )
}
